const comments = [
  {
    user: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个平台太猛了，好多料都是第一次看到！比那些遮遮掩掩的娱乐号强太多了，真的是全网黑料一网打尽。',
    likes: 283,
  },
  {
    user: '深夜吃瓜人',
    time: '5小时前',
    content: '连续蹲了一周了，每天都有新瓜，比追剧还上瘾。911吃瓜网已经成为我每天的必刷站点，更新速度真的快。',
    likes: 196,
  },
  {
    user: '匿名网友A',
    time: '8小时前',
    content: '有一说一，这里的黑料合集整理得太到位了，按明星、网红分类清清楚楚，新人也能快速找到想吃的瓜。',
    likes: 157,
  },
  {
    user: '瓜田守望者',
    time: '12小时前',
    content: '爆料通道真的很安全，之前投的料很快就发出来了，而且完全没有泄露我的任何信息，给大家点赞。',
    likes: 134,
  },
  {
    user: '夏天的瓜最甜',
    time: '1天前',
    content: '从微博追过来的，还是这里料更全更猛。内幕曝光栏目简直是宝藏，建议大家都来看看，吃瓜必备神器。',
    likes: 98,
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          瓜友热议
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          吃瓜群众真实反馈，来看看大家都在聊什么
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-50 rounded-xl border border-secondary-200/60 p-5 hover:border-primary-200 transition-colors duration-200">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-accent-700">{c.user.charAt(0)}</span>
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-800 truncate">{c.user}</p>
                  <p className="text-xs text-foreground-400">{c.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-3">{c.content}</p>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i>
                  {c.likes}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}